import { STATUS_LABEL, STATUS_COLOR } from "@/lib/constants";

export function Badge({ status, children }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_COLOR[status] || "bg-cocoa/10 text-cocoa/60"}`}>
      {children || STATUS_LABEL[status] || status}
    </span>
  );
}

export function Money({ value }) {
  return <>${Number(value || 0).toFixed(2)}</>;
}

export function EmptyState({ icon: Icon, title, body, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-cocoa/15 bg-warmwhite py-16 text-center" data-testid="empty-state">
      {Icon && <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-terracotta/10 text-terracotta"><Icon strokeWidth={1.4} className="h-7 w-7" /></span>}
      <h3 className="font-serif text-xl text-cocoa">{title}</h3>
      {body && <p className="mt-2 max-w-sm text-sm text-cocoa/60">{body}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return <div className={`rounded-2xl border border-cocoa/10 bg-warmwhite p-6 shadow-[0_4px_20px_rgba(64,53,47,0.04)] ${className}`} {...rest}>{children}</div>;
}

export function SectionTitle({ children, action }) {
  return (
    <div className="mb-4 flex items-center justify-between">
      <h2 className="font-serif text-xl font-semibold text-cocoa">{children}</h2>
      {action}
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {[...Array(3)].map((_, i) => <div key={i} className="h-28 animate-pulse rounded-2xl bg-cocoa/5" />)}
    </div>
  );
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = iso.length <= 10 ? new Date(iso + "T00:00:00") : new Date(iso);
  return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export function formatTime(hhmm) {
  if (!hhmm) return "";
  const parts = String(hhmm).split(":");
  const h = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return hhmm;
  const suffix = h < 12 ? "AM" : "PM";
  const hr = h % 12 || 12;
  return `${hr}:${String(m).padStart(2, "0")} ${suffix}`;
}

export function formatWindow(w) {
  if (!w) return "";
  return `${formatTime(w.start)} – ${formatTime(w.end)}`;
}
